import axios from 'axios'

const API_URL = `/api/`;
const AXIOS = axios.create({
  baseURL: API_URL,
  timeout: 10000
});

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
}

class OfferService {
  findCompanies(query) {
    if (query) {
      return AXIOS.get("offer/companies/?query=" + query);
    } else {
      return AXIOS.get("offer/companies/");
    }
  }

  findCompany(id) {
    return AXIOS.get("offer/companies/" + id);
  }

  findContactPersonByCompany(id) {
    return AXIOS.get("offer/companies/" + id + "/contacts")
  }

  findDealMakers() {
    // return AXIOS.get("user/all")
    return AXIOS.get("offer/companies/dealmakers")
  }

  createOffer(offer) {
    return AXIOS.post("offer/offer/", offer, config)
  }
}


export default new OfferService();